"use client";

const TermsOfUse = () => {
  return (
    <>
      <div style={{ paddingInline: "34px" }}>
        <h1>Terms of Use for PROM.io</h1>
        <p>
          <strong>Effective Date:</strong> 21st November 2024
        </p>
        <p>
          <strong>Last Updated:</strong> 21st November 2024
        </p>
        <p>
          These Terms of Use (&quot;Terms&quot;) govern your access to and use
          of the PROM.io platform and related services (the
          &quot;Services&quot;), operated by PROMTECH SOLUTIONS LTD
          (&quot;PROMTECH&quot;), a company incorporated under the laws of the
          British Virgin Islands (BVI), with registration number 2159546. he
          legal address (“Registered Office”) of PROMTECH is 1st Floor, Columbus
          Centre, PO Box 2283, Road Town, Tortola VG 1110, British Virgin
          Islands.
        </p>
        <p>
          By accessing or using the Services, you acknowledge that you have
          read, understood, and agree to be bound by these Terms. If you do not
          agree with any part of these Terms, you must not access or use the
          Services.
        </p>

        <h1>1. Introduction</h1>
        <p>
          PROM.io is a website-hosted user interface (&quot;Platform&quot;) that
          facilitates access to various products, services, and information
          related to or built on the PROM zkEVM blockchain network or
          infrastructure. While the Platform connects users to decentralized
          applications, services, and protocols, PROMTECH does not provide,
          manage, or oversee any financial products or third-party applications
          available on the Platform.
        </p>
        <p>
          PROMTECH operates and maintains the blockchain infrastructure but does
          not:
        </p>
        <ul>
          <li>
            Provide Financial, Investment, or Advisory Services: PROMTECH does
            not offer any financial advice or investment recommendations.
          </li>
          <li>
            Act as a Custodian or Intermediary: PROMTECH does not hold or manage
            digital assets on your behalf.
          </li>
          <li>
            Guarantee Third-Party Services: PROMTECH does not guarantee the
            accuracy, availability, or reliability of third-party services
            accessible via the Platform.
          </li>
        </ul>
        <p>
          All products, services, and decentralized applications available
          through PROM.io are solely operated, owned, and provided by
          third-party entities. By using these services or applications, you
          confirm that you understand and agree to adhere to any applicable
          terms and conditions required by such third-party providers.
        </p>

        <h2>1.1 No Affiliation with Third-Party Services</h2>
        <p>
          The availability of third-party services on PROM.io does not
          constitute endorsement, partnership, or affiliation with PROMTECH.
          PROMTECH does not control or take responsibility for:
        </p>
        <ul>
          <li>
            The performance, reliability, legality, or security of third-party
            services or applications.
          </li>
          <li>
            Any disputes, losses, or issues arising from your interaction with
            third-party entities.
          </li>
        </ul>

        <h2>1.2 User Consent and Responsibility</h2>
        <p>By using PROM.io, you acknowledge and agree that:</p>
        <ul>
          <li>
            <strong>Security of Credentials:</strong> You are solely responsible
            for securing your access credentials, private keys, and digital
            assets. PROM.io does not offer recovery services for lost keys or
            unauthorized access.
          </li>
          <li>
            <strong>Compliance with Laws:</strong> You are responsible for
            ensuring that your use of the Services complies with all applicable
            laws, regulations, and policies in your jurisdiction.
          </li>
          <li>
            <strong>Assumption of Risk:</strong> You assume all risks associated
            with blockchain transactions, including financial loss, market
            volatility, and technological failures.
          </li>
        </ul>

        <h2>1.3 Risk of Loss in Digital Assets</h2>
        <p>By accessing PROM.io, you agree that:</p>
        <ul>
          <li>
            Volatility of Digital Assets: <br />
            The value of digital assets is highly volatile and may result in
            significant financial loss.
          </li>
          <li>
            Irreversibility of Transactions: <br />
            Blockchain transactions are irreversible; errors in transaction
            details cannot be corrected.
          </li>
          <li>
            No liability for Losses: <br />
            PROMTECH is not responsible for any losses, damages, or liabilities
            you incur due to your use of the Services.
          </li>
        </ul>

        <h2>1.4 Acceptance of Terms</h2>
        <p>
          Your access to and use of PROM.io is contingent upon your full
          agreement with these Terms. If you do not agree, you must discontinue
          use immediately.
        </p>

        <h1>2. Eligibility</h1>
        <h2>2.1 Age Requirement</h2>
        <p>
          You must be at least 18 years old or the legal age of majority in your
          jurisdiction, whichever is greater, to access or use the Services. By
          accessing or using the Services, you represent and warrant that you
          meet this requirement.
        </p>

        <h2>2.2 Compliance with Laws</h2>
        <p>
          Lawful use: <br />
          You agree that your use of the Services will fully comply with all
          applicable laws and regulations. You represent and warrant that:
        </p>
        <ul>
          <li>
            Your use of the Services does not violate any laws or regulations
            applicable to you.
          </li>
          <li>
            Prohibited Activities: <br />
            You will not use the Services to conduct, promote, or facilitate any
            illegal activities.
          </li>
        </ul>

        <h2>2.3 Sanctions and Restricted Parties</h2>
        <p>You represent and warrant that you are not:</p>
        <ul>
          <li>
            Subject to economic or trade sanctions administered by any
            governmental authority.
          </li>
          <li>
            Listed on any prohibited or restricted party list issued by any
            governmental authority.
          </li>
          <li>
            A citizen, resident, or entity established in a jurisdiction subject
            to comprehensive sanctions (e.g., Cuba, Iran, North Korea, Syria, or
            Crimea).
          </li>
        </ul>
        <p>
          PROMTECH reserves the right to terminate your access to the Services
          if it determines that your use violates this provision.
        </p>

        <h2>2.4 User Responsibility</h2>
        <p>
          You are solely responsible for ensuring that your use of the Services
          complies with all applicable laws. PROMTECH is not responsible for
          verifying the legality of your activities.
        </p>

        <h1>3. Modification of Terms</h1>
        <p>
          3.1. Right to Modify: <br />
          PROMTECH reserves the right to modify, update, or amend these Terms at
          any time, at its sole discretion.
        </p>
        <p>
          3.2 Notice of Modifications: <br />
          Updated Terms will be posted on the PROM.io website with a revised
          &quot;Effective Date.&quot; It is your responsibility to regularly
          review these Terms for updates.
        </p>
        <p>
          3.3 Notice of Modifications: <br />
          All modifications become effective immediately upon posting unless
          otherwise specified. Your continued use of the Services constitutes
          acceptance of the updated Terms.
        </p>
        <p>
          3.4 Notice of Modifications: <br />
          If you do not agree to any modifications, you must discontinue use of
          the Services immediately.
        </p>

        <h1>4. Proprietary Rights</h1>
        <h2>4.1 Intellectual Property Ownership</h2>
        <p>
          All intellectual property rights in the PROM.io Platform
          (&quot;Platform Content&quot;) are owned by or licensed to PROMTECH.
          <strong>You acknowledge that:</strong>
        </p>
        <ul>
          <li>
            <strong>Protection of Content:</strong> Platform Content is
            protected by intellectual property laws globally.
          </li>
          <li>
            <strong>No License Granted:</strong> Use of the Services does not
            grant you ownership or rights to Platform Content.
          </li>
        </ul>

        <h2>4.2 Open-Source Protocols and Third-Party Technologies</h2>
        <p>
          PROM.io may integrate open-source protocols and third-party
          technologies. You acknowledge that:
        </p>
        <ul>
          <li>
            <strong>No Control Over Protocols:</strong> PROMTECH does not own or
            control these protocols.
          </li>
          <li>
            <strong>Assumption of Risk:</strong> You accept risks associated
            with protocol changes, forks, or failures.
          </li>
        </ul>

        <h2>4.3 User Restrictions</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Copy, modify, or distribute Platform Content.</li>
          <li>Use automated tools to access the Services without consent.</li>
          <li>
            Reverse engineer or create derivative works based on Platform
            Content.
          </li>
          <li>Circumvent security features or usage rules.</li>
        </ul>
        <p>Any unauthorized use may result in termination and legal action.</p>

        <h1>5. Assumption of Risk</h1>
        <p>
          By using PROM.io, you acknowledge and accept the inherent risks
          associated with blockchain technology and digital assets.
        </p>
        <h2>5.1 User Responsibility and Sophistication</h2>
        <p>You represent and warrant that you:</p>
        <ul>
          <li>
            Are financially and technically sophisticated regarding blockchain
            systems.
          </li>
          <li>
            Understand the characteristics and risks of blockchain transactions.
          </li>
          <li>Accept full responsibility for your decisions and actions.</li>
        </ul>

        <h2>5.2 Risks of Blockchain Transactions</h2>
        <p>You understand that:</p>
        <ul>
          <li>
            <strong>Irreversible Transactions:</strong> Errors may result in
            permanent loss of funds.
          </li>
          <li>
            <strong>Transaction Delays and Failures:</strong> Network issues may
            cause delays or failures.
          </li>
        </ul>

        <h2>5.3 Market Volatility</h2>
        <p>You acknowledge that:</p>
        <ul>
          <li>
            <strong>High Volatility:</strong> Digital assets can fluctuate
            significantly.
          </li>
          <li>
            <strong>No Financial Advice:</strong> PROMTECH does not provide
            investment advice.
          </li>
        </ul>

        <h2>5.4 Security Risks</h2>
        <p>You accept that:</p>
        <ul>
          <li>
            <strong>Wallet Compromise:</strong> Loss of credentials may result
            in asset loss.
          </li>
          <li>
            <strong>Phishing and Hacking:</strong> You may be targeted by
            malicious activities.
          </li>
          <li>
            <strong>Third-Party Vulnerabilities:</strong> PROM.io relies on
            third-party services that may be vulnerable.
          </li>
        </ul>

        <h2>5.5 Token Risks</h2>
        <p>You acknowledge that:</p>
        <ul>
          <li>
            <strong>Counterfeit Tokens:</strong> Fake tokens may exist.
          </li>
          <li>
            <strong>Mistaken Transactions:</strong> Errors may lead to financial
            losses.
          </li>
          <li>
            <strong>Liquidity Issues:</strong> Tokens may lack liquidity.
          </li>
        </ul>

        <h2>5.6 Costs of Transactions</h2>
        <p>You understand that:</p>
        <ul>
          <li>
            <strong>Variable Costs:</strong> Transaction costs and speeds vary.
          </li>
          <li>
            <strong>Price Slippage:</strong> Trading may result in unfavorable
            rates.
          </li>
        </ul>

        <h2>5.7 Regulatory and Legal Risks</h2>
        <p>You acknowledge that:</p>
        <ul>
          <li>
            <strong>Evolving Laws:</strong> Regulations may affect your use of
            PROM.io.
          </li>
          <li>
            <strong>No Legal Guidance:</strong> You are responsible for
            compliance in your jurisdiction.
          </li>
        </ul>

        <h2>5.8 Full Assumption of Risk</h2>
        <p>By using PROM.io, you:</p>
        <ul>
          <li>Accept all associated risks.</li>
          <li>Acknowledge that PROMTECH is not liable for losses.</li>
        </ul>
        <p>If you do not agree, you must not use PROM.io.</p>

        <h1>6. Use of Services</h1>
        <h2>6.1 User Responsibilities</h2>
        <p>By using the Services, you agree to:</p>
        <ul>
          <li>
            Safeguard Credentials: Secure your wallet, private keys, and
            passwords.
          </li>
          <li>
            Ensure Compliance: Comply with all applicable laws and regulations.
          </li>
          <li>
            Avoid Financial Reliance: Make decisions at your own risk; PROM.io
            does not provide financial advice.
          </li>
        </ul>

        <h2>6.2 Prohibited Activities</h2>
        <p>You agree not to engage in:</p>
        <ul>
          <li>Intellectual Property Infringement</li>
          <li>Cyberattacks and Technical Exploits</li>
          <li>Fraud and Misrepresentation</li>
          <li>Market Manipulation</li>
          <li>Securities and Derivatives Violations</li>
          <li>Unlawful Activities</li>
          <li>Unauthorized Access and Use</li>
          <li>Use of Automated Tools without Consent</li>
        </ul>
        <p>
          Engaging in prohibited activities may result in termination and legal
          action.
        </p>

        <h1>7. Third-Party Services</h1>
        <h2>7.1 Access to Third-Party Services</h2>
        <p>
          PROM.io may provide access to third-party applications and services
          (&quot;Third-Party Services&quot;). PROMTECH does not own or control
          these services.
        </p>

        <h2>7.2 Disclaimer of Responsibility</h2>
        <p>You acknowledge that:</p>
        <ul>
          <li>
            No Endorsement: Inclusion of Third-Party Services does not imply
            endorsement.
          </li>
          <li>
            No Control or Liability: PROMTECH is not responsible for Third-Party
            Services&quot; performance or legality.
          </li>
        </ul>

        <h2>7.3 User Responsibility</h2>
        <p>By using Third-Party Services, you agree to:</p>
        <ul>
          <li>Conduct Due Diligence: Evaluate suitability and risks.</li>
          <li>Assume Risk: Use at your own risk.</li>
          <li>
            Indemnify PROMTECH: Hold PROMTECH harmless from claims arising from
            your use of Third-Party Services.
          </li>
        </ul>

        <h2>7.4 Third-Party Promotions</h2>
        <p>
          PROMTECH is not responsible for third-party promotions and any
          participation is at your own risk.
        </p>

        <h2>7.5 Limitation of Liability for Third-Party Services</h2>
        <p>
          PROMTECH disclaims all liability arising from your use of Third-Party
          Services.
        </p>

        <h1>8. Non-Custodial and No Fiduciary Duties</h1>
        <h2>8.1 Non-Custodial Nature of the Platform</h2>
        <p>PROM.io is a non-custodial platform:</p>
        <ul>
          <li>
            User Asset Responsibility: You manage your private keys and digital
            assets.
          </li>
          <li>
            No Access to Assets: PROMTECH does not store or access your assets.
          </li>
          <li>
            No Recovery Services: PROMTECH cannot recover lost credentials or
            assets.
          </li>
        </ul>

        <h2>8.2 No Fiduciary Relationship</h2>
        <p>You acknowledge that:</p>
        <ul>
          <li>
            No Fiduciary Duties: PROMTECH owes no fiduciary duties to you.
          </li>
          <li>
            Transactional Platform: PROM.io does not act in your best interest
            or provide guidance.
          </li>
        </ul>

        <h2>8.3 No Investment Advice or Suitability Assessments</h2>
        <ul>
          <li>
            No Investment Advice: PROM.io provides information for informational
            purposes only.
          </li>
          <li>
            User Responsibility: You are responsible for evaluating transactions
            and investments.
          </li>
        </ul>

        <h2>8.4 Limitation of Duties and Liabilities</h2>
        <p>By using PROM.io, you agree that:</p>
        <ul>
          <li>
            No Implied Duties: PROMTECH owes no implied duties beyond these
            Terms.
          </li>
          <li>
            Waiver of Claims: You waive claims arising from alleged fiduciary
            duties.
          </li>
        </ul>

        <h1>9. Indemnification</h1>
        <h2>9.1 General Indemnification Obligations</h2>
        <p>
          You agree to indemnify, defend, and hold harmless PROMTECH and its
          Indemnified Parties from any claims arising out of:
        </p>
        <ul>
          <li>Your Use of the Services</li>
          <li>Your Violation of These Terms</li>
          <li>Third-Party Claims</li>
          <li>Your Fraudulent or Negligent Acts</li>
        </ul>

        <h2>9.2 Specific Exclusions</h2>
        <p>PROMTECH is not liable for:</p>
        <ul>
          <li>Errors or Omissions in Content</li>
          <li>Personal Injury or Property Damage</li>
          <li>Operational Interruptions</li>
          <li>Security Breaches</li>
          <li>Market Risks</li>
          <li>Third-Party Conduct</li>
        </ul>

        <h2>9.3 Indemnification Procedure</h2>
        <p>If a claim arises:</p>
        <ul>
          <li>Notice of Claim: PROMTECH will notify you promptly.</li>
          <li>
            Defense and Settlement: You must defend and may not settle without
            PROMTECH&quot;s consent.
          </li>
        </ul>

        <h2>9.4 Limitation of Liability</h2>
        <ul>
          <li>
            Cap on Liability: PROMTECH&quot;s total liability will not exceed
            USD $100.00 or the amount you paid in the preceding 12 months.
          </li>
          <li>
            Exclusion of Certain Damages: PROMTECH is not liable for indirect or
            consequential damages.
          </li>
          <li>
            Jurisdictional Limitations: Liability is limited to the fullest
            extent permitted by law.
          </li>
        </ul>

        <h2>9.5 Severability of Indemnity Provisions</h2>
        <p>
          Each provision is independent; unenforceability of one does not affect
          others.
        </p>

        <h1>10. Limitation of Liability</h1>
        <h2>10.1 General Disclaimer</h2>
        <p>PROM.io is provided &quot;as-is&quot; without warranties.</p>

        <h2>10.2 Exclusions of Liability</h2>
        <p>PROMTECH is not liable for:</p>
        <ul>
          <li>Loss of Funds or Data</li>
          <li>Delays or Failures</li>
          <li>Security Breaches</li>
          <li>Errors or Omissions</li>
          <li>Third-Party Conduct</li>
          <li>Market Risks</li>
        </ul>

        <h2>10.3 Limitation of Liability</h2>
        <p>
          Total liability is capped at USD $100.00 or the amount paid by you in
          the preceding 12 months.
        </p>

        <h2>10.4 Specific Exclusions</h2>
        <p>PROMTECH is not liable for:</p>
        <ul>
          <li>Loss of Profits or Revenue</li>
          <li>Reputational Harm</li>
          <li>Data Loss</li>
          <li>Consequential Damages</li>
          <li>Force Majeure Events</li>
        </ul>

        <h2>10.5 Jurisdictional Limitations</h2>
        <p>Some exclusions may not apply in certain jurisdictions.</p>

        <h2>10.6 Allocation of Risk</h2>
        <p>These limitations are fundamental to this Agreement.</p>

        <h2>10.7 User Responsibility</h2>
        <p>You agree to secure your assets and assume risks.</p>

        <h1>11. Trading Halts and Operational Disruptions</h1>
        <h2>11.1 Potential Causes of Disruptions</h2>
        <p>
          Transactions may be disrupted due to factors beyond PROMTECH&quot;s
          control.
        </p>

        <h2>11.2 PROMTECH’s Responsibilities</h2>
        <p>
          PROMTECH will make reasonable efforts to monitor and restore services.
        </p>

        <h2>11.3 Limitations of Liability</h2>
        <p>PROMTECH is not liable for damages resulting from disruptions.</p>

        <h2>11.4 User Assumption of Risk</h2>
        <p>You accept that disruptions may occur and may result in loss.</p>

        <h2>11.5 Reserved Rights</h2>
        <p>PROMTECH reserves the right to suspend services as necessary.</p>

        <h2>11.6 Force Majeure</h2>
        <p>PROMTECH is not liable for events beyond its control.</p>

        <h1>12. Privacy and Data Collection</h1>
        <h2>12.1 Minimal Data Collection</h2>
        <p>PROM.io collects minimal data necessary for operation.</p>

        <h2>12.2 Use of Collected Data</h2>
        <p>Data is used solely for functionality, security, and compliance.</p>

        <h2>12.3 Third-Party Data Collection</h2>
        <p>
          Third-party providers may collect additional data; PROMTECH is not
          responsible for their practices.
        </p>

        <h2>12.4 User Acknowledgment and Consent</h2>
        <p>By using PROM.io, you consent to data collection as described.</p>

        <h2>12.5 Data Protection Measures</h2>
        <p>PROMTECH employs security measures to protect data.</p>

        <h2>12.6 Data Retention Policy</h2>
        <p>Data is retained only as long as necessary.</p>

        <h2>12.7 User Rights and Control</h2>
        <p>
          You may have rights concerning your data; contact PROMTECH to exercise
          them.
        </p>

        <h2>12.8 Compliance with Global Privacy Regulations</h2>
        <p>
          PROMTECH complies with relevant privacy laws, such as GDPR and CCPA.
        </p>

        <h2>12.9 Disclaimer of Liability</h2>
        <p>
          PROMTECH is not liable for data disclosed via blockchain or breaches
          by third parties.
        </p>

        <h1>13. Suspension, Termination, and Cancellation</h1>
        <h2>13.1 Platform-Specific Access Control</h2>
        <p>
          PROMTECH may suspend or terminate access to its services under certain
          conditions.
        </p>

        <h2>13.2 Limitations of Suspension on Public Blockchain</h2>
        <p>
          PROMTECH cannot restrict access to the public zkEVM blockchain through
          third-party tools.
        </p>

        <h2>13.3 Notice of Suspension or Termination</h2>
        <p>
          PROMTECH will provide notice where feasible and legally permissible.
        </p>

        <h2>13.4 No Liability for Suspension or Termination</h2>
        <p>
          PROMTECH is not liable for losses resulting from suspension or
          termination.
        </p>

        <h2>13.5 User Responsibilities Following Suspension or Termination</h2>
        <p>
          You are responsible for retrieving data and complying with legal
          obligations.
        </p>

        <h2>13.6 Reserved Rights</h2>
        <p>
          PROMTECH reserves the right to suspend services without notice in
          certain circumstances.
        </p>

        <h1>14. Entire Agreement</h1>
        <p>
          These Terms constitute the entire agreement between you and PROMTECH
          and supersede all prior agreements.
        </p>

        <h1>15. Governing Law and Dispute Resolution</h1>
        <h2>15.1 Governing Law</h2>
        <p>
          These Terms are governed by the laws of the British Virgin Islands.
        </p>

        <h2>15.2 Mandatory Arbitration</h2>
        <p>
          Disputes will be resolved through binding arbitration under BVI IAC
          rules.
        </p>

        <h2>15.3 Arbitration Process</h2>
        <ul>
          <li>Single Arbitrator: Appointed per BVI IAC rules.</li>
          <li>Language: English.</li>
          <li>Location: British Virgin Islands or virtually.</li>
          <li>Final Decision: Binding and enforceable.</li>
        </ul>

        <h2>15.4 Class Action Waiver</h2>
        <p>You waive the right to participate in class actions.</p>

        <h2>15.5 Pre-Arbitration Resolution</h2>
        <p>Attempt to resolve disputes informally by contacting PROMTECH.</p>

        <h2>15.6 No Liability for External Factors</h2>
        <p>
          PROMTECH is not liable for breaches resulting from unforeseeable
          circumstances.
        </p>

        <h1>16. Contact Information</h1>
        <p>
          For inquiries regarding these Terms, please contact:
          <br />
          <strong>PROMTECH SOLUTIONS LTD</strong>
          <br />
          1st Floor, Columbus Centre, PO Box 2283, Road Town Tortola VG 1110,
          British Virgin Islands
          <br />
          <a href="mailto:info@prometeus.io">info@prometeus.io</a>
        </p>
      </div>
    </>
  );
};

export default TermsOfUse;
